export default __webpack_public_path__ + "1a795fa88d6cbd9f3b3e09836cfa52e9.svg";